export { default as BlocSettingsPage } from "./BlocSettingsPage";
export { default as BlocSettingsForm } from "./BlocSettingsForm";



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/settings/index.js